﻿
export class Directive implements ng.IDirective {
    public priority: number;
    public template: string;
    public templateUrl: string;
    public replace: boolean;
    public transclude: any;
    public restrict: string;
    public scope: any;
    public link: (
        scope: ng.IScope,
        instanceElement: ng.IAugmentedJQuery,
        instanceAttributes: ng.IAttributes,
        controller: any,
        transclude: ng.ITranscludeFunction
    ) => void;
    public compile: (
        templateElement: ng.IAugmentedJQuery,
        templateAttributes: ng.IAttributes,
        transclude: ng.ITranscludeFunction
    ) => any;
    public controller: any;
    public require: any;
    public terminal: boolean;
    public $$tlb: boolean;
}
